import styled from 'styled-components';

interface TagBadgeProps {
  label: string;
}

const TagBadge = ({ label }: TagBadgeProps) => {
  return <StyledTag>{label}</StyledTag>;
};

export default TagBadge;

const StyledTag = styled.div`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 99px;
  background: var(--Primary-lightgray, #f3f3f3);

  color: var(--Primary-darkgray, #000c24);
  text-align: right;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.28px;
`;
